import { render, staticRenderFns } from "./AnalysisDetailCard.vue?vue&type=template&id=3d006da4&scoped=true&"
import script from "./AnalysisDetailCard.vue?vue&type=script&lang=js&"
export * from "./AnalysisDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisDetailCard.vue?vue&type=style&index=0&id=3d006da4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d006da4",
  null
  
)

export default component.exports